import { useQuery } from '@percent/utility'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'

export const useCanUseGrants = () => {
  const { grantsService } = useServices()

  const {
    data: candidatesData,
    status: candidatesStatus,
    isLoading: isLoadingCandidates
  } = useQuery(['grants-candidates'], grantsService.getCandidates, {})

  if (isLoadingCandidates || candidatesStatus === 'error' || candidatesData?.length === 0) {
    return false
  }

  return true
}
